import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './components/store';
import ScrollToTop from './components/scrollToTop';
import CartDrawer from './components/cartList';
import ContactForm from './components/contactUS';
import Login from './components/login';
import SignUp from './components/signUp';
import PaymentInformation from './components/paymentInformation';
import DeliverySection from './components/deliverySection';
import PopularCarSection from './components/omneet/latestNotes';
import Orderpage from './components/order';
import AllSeeModels from "./components/allSeeModels";
import BasicSelectFilter from './components/filter';
import BrandFilter from './components/searchPage';
import ProductPage from "./components/productPage"
import BrandSearchPage from "./components/brandSearchResult"
import Brand from './components/brand';
import AboutUs from './components/aboutUs';
import LogInPopup from './components/loginPopup';
import Disclaimer from './components/disclaimer';
import PrivacyPolicy from './components/privacyPolicy';
import SecurePayment from './components/securePayment';
import TermsandCondition from './components/termsandCondition';
import GlobalSearch from './components/globalSearch';
import AddressForm from './components/myAddress';
import ExploreByGlobalSearch from './components/exploreByGlobalSearch';
import ModelNameByGlobalSearch from './components/modelNameByGlobalSearch';
import Wishlist from './components/wishList';
import FilterByGlobalSearch from './components/filterByGlobalSearch';
import MyAccount from './components/myAccount';
import MyProfile from './components/myProfile';
import OrderHistory from './components/orderHistory';
import InquiryHistory from './components/inquiryHistory';
import LandingPage from './components/landingPage';
import AdminLogin from './components/adminLogin';
import AdminDashboard from './components/adminDashBoard';
import ProtectedRoute from './components/protectedRoute';
import AllOrders from './components/allOrders';
import AddNewCar from './components/addNewCar';
import AllInquiries from './components/allInquiries';
import AllUsers from './components/allUsers';
import SeeAllPopularCarModels from './components/seeAllPopularCarModels';
import SeeAllAffordableCarModels from './components/seeAllAffordableCarModels';
import ProductReviewInterface from './components/productReview';
import MoreFilterByGlobalSearch from './components/moreFilterByGlobalSearch';
import AddNewAccessories from './components/addnewAccessories';
import AllCarListed from './components/allCarListed';
import HistoryTickets from './components/ticketHistory';
import DataManagementUI from './components/dataManagementUI';
import PurchaseFlow from './components/purchaseFlow';
import ShippingPolicy from './components/shippingPolicy';
import WhyChooseAmarEnterprises from './components/whyChooseAmarEnterprises';
import OfficialBankDetails from './components/officialBankDetails';
import OurServices from './components/ourServices';
import ReturnsPolicy from './components/returnsPolicy';
import Faqs from './components/faqs';
import UserReviews from './components/userReview';
import ReviewSection from './components/reviewSection';
import ProcessOrder from './components/processOrder';
import SendFinalPerformaInvoice from './components/sendFinalPerformaInvoice';
import AllFinalPerformaInvoice from './components/allFinalPerformaInvoice';
import UserPerformaInvoices from './components/userPerformaInvoices';
import SetPriceMargin from './components/setPriceMargin';
import InquiryTickets from './components/inquiryTickets';

const AppRoutes = () => {
  return (
    <Provider store={store}>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/cart" element={<CartDrawer />} />
          <Route path="/contactUs" element={<ContactForm />} />
          <Route path="/logIn" element={<Login />} />
          <Route path="/signUp" element={<SignUp />} />
          <Route path="/payment" element={<PaymentInformation />} />
          <Route path="/delivery" element={<DeliverySection />} />
          <Route path="/latestNotes" element={<PopularCarSection />} />
          <Route path="/order" element={<Orderpage />} />
          <Route path="/brand/:brandName" element={<AllSeeModels />} />
          <Route path="/product/:modelId" element={<ProductPage />} />
          <Route path="/filter" element={<BasicSelectFilter />} />
          <Route path="/searchPage" element={<BrandFilter />} />
          <Route path="/FilterByGlobalSearch" element={<FilterByGlobalSearch />} />
          <Route path="/MoreFilterByGlobalSearch" element={<MoreFilterByGlobalSearch />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/search" element={<BrandSearchPage />} />
          <Route path="/brand" element={<Brand />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/loginpopup" element={<LogInPopup />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/securePayment" element={<SecurePayment />} />
          <Route path="/termsandCondition" element={<TermsandCondition />} />
          <Route path="/globalSearch" element={<GlobalSearch />} />
          <Route path="/exploreByGlobalSearch" element={<ExploreByGlobalSearch />} />
          <Route path="/modelNameByGlobalSearch/:modelName" element={<ModelNameByGlobalSearch />} />
          <Route path="/seeAllPopularCarModels" element={<SeeAllPopularCarModels />} />
          <Route path="/seeAllAffordableCarModels" element={<SeeAllAffordableCarModels />} />
          <Route path="/adminLogin" element={<AdminLogin />} />
          <Route path="/productReview" element={<ProductReviewInterface />} />
          <Route path="/purchaseFlow" element={<PurchaseFlow />} />
          <Route path="/shippingPolicy" element={<ShippingPolicy />} />
          <Route path="/whyChooseAmarEnterprises" element={<WhyChooseAmarEnterprises />} />
          <Route path="/officialBankDetails" element={<OfficialBankDetails />} />
          <Route path="/ourServices" element={<OurServices />} />
          <Route path="/returnsPolicy" element={<ReturnsPolicy />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/ReviewSection" element={<ReviewSection />} />
          <Route path="/inquiryTickets/:shippingCalculationId" element={<InquiryTickets />} />

          {/* MyAccount nested routes */}
          <Route path="/myAccount" element={<MyAccount />} />
          <Route path="/myAccount/orderHistory" element={<OrderHistory />} />
          <Route path="/myAccount/inquiryHistory" element={<InquiryHistory />} />
          <Route path="/myAccount/userReview" element={<UserReviews />} />
          <Route path="/myAccount/wishList" element={<Wishlist />} />
          <Route path="/myAccount/myProfile" element={<MyProfile />} />
          <Route path="/myAccount/myAddress" element={<AddressForm />} />
          <Route path="/myAccount/ticketHistory" element={<HistoryTickets />} />
          <Route path="/myAccount/ticketHistory/:shippingCalculationId" element={<HistoryTickets />} />
          <Route path="/myAccount/orderTicketHistory/:orderId" element={<HistoryTickets />} />
          <Route path="/myAccount/userPerformaInvoices" element={<UserPerformaInvoices />} />

          {/* Admin Dashboard with nested routes (handles all /adminDashBoard/* paths) */}
          <Route
            path="/adminDashBoard/*"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          {/* Legacy Admin Routes */}
          <Route
            path="/allOrders"
            element={
              <ProtectedRoute>
                <AllOrders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/addNewCar"
            element={
              <ProtectedRoute>
                <AddNewCar />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AllInquiries"
            element={
              <ProtectedRoute>
                <AllInquiries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/allUsers"
            element={
              <ProtectedRoute>
                <AllUsers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/allNewAccessories"
            element={
              <ProtectedRoute>
                <AddNewAccessories />
              </ProtectedRoute>
            }
          />
          <Route
            path="/allCarListed"
            element={
              <ProtectedRoute>
                <AllCarListed />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dataManagementUI"
            element={
              <ProtectedRoute>
                <DataManagementUI />
              </ProtectedRoute>
            }
          />
          <Route
            path="/processOrder/:inquiryId"
            element={
              <ProtectedRoute>
                <ProcessOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sendFinalPerformaInvoice/:inquiryId"
            element={
              <ProtectedRoute>
                <SendFinalPerformaInvoice />
              </ProtectedRoute>
            }
          />
          <Route
            path="/allFinalPerformaInvoice"
            element={
              <ProtectedRoute>
                <AllFinalPerformaInvoice />
              </ProtectedRoute>
            }
          />

          {/* Set Price Margin — standalone protected route */}
          <Route
            path="/setPriceMargin"
            element={
              <ProtectedRoute>
                <SetPriceMargin />
              </ProtectedRoute>
            }
          />

        </Routes>
      </Router>
    </Provider>
  );
};

export default AppRoutes;